import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

const currentUrl = window.location.href;

const instance = axios.create({
    headers: {
        'Authorization': 'Bearer QG0O5TV1xcGgpaCsEGuTJgXsBec9rJWY6xB9bo9PuNE2TNEps3',
        'Url': currentUrl
    }
});

function getDistance(origin, destination) {
    if (!origin || !destination) {
        return null;
    }

    const originLatRadius = (Math.PI * origin.lat) / 180;
    const destinationLatRadius = (Math.PI * destination.lat) / 180;
    const thetaRadius = (Math.PI * (origin.lng - destination.lng)) / 180;
    let dist =
        Math.sin(originLatRadius) * Math.sin(destinationLatRadius) +
        Math.cos(originLatRadius) * Math.cos(destinationLatRadius) * Math.cos(thetaRadius);

    if (dist > 1) {
        dist = 1;
    }

    return ((Math.acos(dist) * 180) / Math.PI) * 60 * 1.1515;
}

export default new Vuex.Store({
    state: {
        apiUrl:
            process.env.NODE_ENV === 'production'
                ? process.env.MIX_QHS_CONSOLE_API_PROD
                : process.env.MIX_QHS_CONSOLE_API_LOCAL,
        filters: {},
        totalProviders: 0,
        providers: [],
        nextPageUrl: null,
        loading: false,
        filterSelections: {},
        searchedProviders: [],
        totalLocations: 0,
        locations: [],
        locationsLoaded: false,
        searchedLocations: [],
        mapCenter: {lat: 20.4507582, lng: -159.7493107},
    },

    mutations: {
        setFilters(state, filters) {
            state.filters = filters;
        },

        setProviders(state, providers) {
            state.totalProviders = providers.total;
            state.providers = providers.data;
            state.nextPageUrl = providers.next_page_url;
        },

        pushProviders(state, providers) {
            state.providers.push(...providers.data);
            state.nextPageUrl = providers.next_page_url;
        },

        setLoading(state, loading) {
            state.loading = loading;
        },

        setFilterSelections(state, selections) {
            return (state.filterSelections = selections);
        },

        setSearchedProviders(state, providers) {
            state.searchedProviders = providers;
        },

        setLocations(state, locations) {
            state.totalLocations = locations.length;
            state.locations = locations.map(location => {
                location.distance = null;

                return location;
            });
            state.locationsLoaded = true;
            window.qhsEvents.$emit('locationsLoaded');
        },

        setSearchedLocations(state, locations) {
            state.searchedLocations = locations;
        },
    },

    actions: {
        async getProviderFilters({state, commit}, params = {}) {
            const {data} = await instance.get(state.apiUrl + '/provider-filters', {params});
            commit('setFilters', data);

            return state.filters;
        },

        getProviders({state, commit}, params = {}) {
            console.log({params});
            commit('setLoading', true);
            instance.get(state.apiUrl + '/providers', {params}).then(({data}) => {
                commit('setProviders', data);
                commit('setLoading', false);
            });
        },

        getNextPageOfProviders({state, commit}, params = {}) {
            commit('setLoading', true);
            instance.get(state.nextPageUrl, {params}).then(({data}) => {
                commit('pushProviders', data);
                commit('setLoading', false);
            });
        },

        updateFilterSelections({commit}, selections) {
            commit('setFilterSelections', selections);
        },

        getSearchedProviders({state, commit}, search) {
            instance.get(state.apiUrl + '/providers', {params: {search}}).then(({data}) => {
                commit('setSearchedProviders', data);
            });
        },

        async getLocationFilters({state, commit}, params = {}) {
            const {data} = await instance.get(state.apiUrl + '/location-filters', {params});
            commit('setFilters', data);

            return state.filters;
        },

        getLocations({state, commit}, params = {}) {
            commit('setLoading', true);
            instance.get(state.apiUrl + '/locations', {params}).then(({data}) => {
                commit('setLocations', data);
                commit('setLoading', false);
            });
        },

        getLocationsById({state, commit}, params = '') {
            commit('setLoading', true);
            instance.get(state.apiUrl + '/locations?' + params).then(({data}) => {
                commit('setLocations', data);
                commit('setLoading', false);
            });
        },

        getSearchedLocations({state, commit}, search) {
            instance.get(state.apiUrl + '/locations', {params: {search}}).then(({data}) => {
                commit('setSearchedLocations', data);
            });
        },

        setDistanceFromLocations({state}, {latitude: lat, longitude: lng}) {
            state.mapCenter = {lat, lng};
            state.locations.forEach(location => {
                location.distance = Math.round(getDistance({lat, lng}, location.coordinates));
            });
            state.locations.sort((a, b) => a.distance - b.distance);
        },

        clearDistanceFromLocations({state}) {
            state.locations.forEach(location => {
                location.distance = null;
            });
        },
    },
});
